import { useCallback, useState } from "react";

// The detail panel's share of the board area, as a fraction. Stored per browser
// (≈ per user) in localStorage and shared across ALL boards + views — only
// relevant while the detail panel is open. A fraction (not px) so the ratio
// holds as the window resizes.
const KEY = "flow:detail-pane-ratio";
const DEFAULT = 0.36;
const MIN = 0.24;
const MAX = 0.62;

function clamp(v: number): number {
  return Math.min(MAX, Math.max(MIN, v));
}

function read(): number {
  try {
    const raw = localStorage.getItem(KEY);
    const v = raw ? Number.parseFloat(raw) : Number.NaN;
    return Number.isFinite(v) ? clamp(v) : DEFAULT;
  } catch {
    return DEFAULT;
  }
}

export function useDetailPaneRatio() {
  const [ratio, setRatioState] = useState<number>(read);
  const setRatio = useCallback((v: number) => {
    const c = clamp(v);
    setRatioState(c);
    try {
      localStorage.setItem(KEY, String(c));
    } catch {
      /* ignore quota/availability errors — the ratio just won't persist */
    }
  }, []);
  return [ratio, setRatio] as const;
}

export const DETAIL_PANE_BOUNDS = { MIN, MAX };
